export default {
      id: "sh-ac-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#sh-ac",
      toString: function () {
        return this.url;
      }
    }